// Colour carries meaning, never identity:
//   ink  = structure
//   flag = a problem (degrading, unresolved, unplaced)
//   live = interactivity, and nothing else
export const PLATES = {
  drawing: {
    bg: "#f2efe8", ink: "#23211d", line: "#8d8a7f", faint: "#cdc7ba",
    mute: "#6d6a62", flag: "#9a3b26", ok: "#3d6b4a", fill: "#fbfaf7",
    live: "#0e6c7a", liveRGB: "14,108,122",
  },
  instrument: {
    bg: "#0d0e0f", ink: "#e8eaea", line: "#3a3e40", faint: "#2e3133",
    mute: "#8d9295", flag: "#d08b3c", ok: "#6fa87f", fill: "#141617",
    live: "#5fc6d4", liveRGB: "95,198,212",
  },
  plate: {
    bg: "#06070a", ink: "#dfe6ee", line: "#263241", faint: "#1b2430",
    mute: "#79828f", flag: "#c2543f", ok: "#5f9c78", fill: "#0a0d12",
    live: "#6aa9c4", liveRGB: "106,169,196",
  },
};
